import { endpoints } from "config/endpoints.config"
import { IGenericModel, generic } from "models/generic"
import { ITransaction } from "./transactions"

export type ITransactionStatusV2 = "waiting_payment" | "canceled" | "paid" | "failed"

export interface SubscriptionPlanV2 {
  current_plan: {
    resources: {
      operators: {
        units: 8
        discount: 99
        price: 79
      }
      channels: {
        unofficial_whatsapp: {
          discount: 99
          price: 249
          units: 2
        }
        instagram: {
          discount: 99
          price: 50
          units: 1
        }
      }
      sms: {
        price: 0.14
        units: 0
      }
    }
    total: 11.8
    prices_table_id: "66b3b45642c1ad3a4c82d935"
    discount_coupon_id: "682275244b53c200ef3532e0"
  }
  _id: "682628b3daaaab63e552f29d"
  cycle_type: "monthly"
  type: "edition"
  author_type: "user"
  author_id: "5"
  created_at: "2025-05-15T17:47:31.962Z"
  version: 13
}

export const transactionsV2: IGenericModel<ITransaction> = {
  ...generic(endpoints.PAYMENT_V2_TRANSACTIONS),
}
